<template>
  <div>
    <div class="mb-10 mt-8" style="width: 50%">
      <h3>
        <span>Import Credit Note Claim Mix</span>
      </h3>
    </div>
    <div class="flex flex-col gap-3 mb-8">
      <div class="flex flex-row">
        <div>
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx, .xls"
            @change="handleChangeFile"
          />
        </div>
        <span>File (xls, xlsx)</span>
      </div>
      <div class="vx-input-group flex space-x-3">
        <vs-button
          class="mt-2"
          color="success"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="handleImport()"
          >Import</vs-button
        >
        <vs-button
          class="mt-2"
          color="success"
          type="border"
          icon-pack="feather"
          icon="icon-download"
          @click="handleDownloadTemplate()"
        >Template Download</vs-button
        >
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-base">
        <vs-tabs v-model="activeTab">
          <vs-tab label="Import">
            <data-table
              :draw="draw"
              @logImportLine="handleLogImportLine"
            ></data-table>
          </vs-tab>
          <vs-tab label="Import Line">
            <detail :logImportID="this.logImportID"> </detail>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./Table.vue";
import Detail from "./Detail.vue";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
export default {
  components: {
    "data-table": Table,
    detail: Detail,
    Datepicker,
    vSelect,
  },

  data() {
    return {
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      activeTab: 0,
      month: null,
      file: null,
      draw: 0,
      logImportID: 0,
    };
  },

  methods: {
    setDefault() {
      this.activeTab = 0;
      this.month = null;
      this.file = null;
      this.logImportID = 0;
      this.$refs.fileInput.value = null;
    },
    handleLogImportLine(id) {
      this.activeTab = 1;
      this.logImportID = id;
    },
    handleDownloadTemplate() {
      this.$vs.loading();
      var fileTitle = "CN_Claim_Mix_TEMPLATE " + moment().format("YYYY-MM-DD");

      // let formData = new FormData();
      // formData.append("type", "ar-invoice");
      const type = "cn-claim-manual";

      this.$http
        .get(`/api/v1/import/begbal-template?type=${type}`, {
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            var fileURL = window.URL.createObjectURL(new Blob([resp]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              fileTitle.toUpperCase() + ".xlsx"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        });
    },
    handleImport() {
      if (!this.file) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "File is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return false;
      }

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("type", "cn-claim-manual");

      this.$vs.loading();
      this.$http
        .post("/api/v1/import/log-begbal", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });

            this.draw++;
            this.setDefault();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    handleChangeFile(event) {
      this.file = event.target.files ? event.target.files[0] : null;

      if (this.file) {
        const reader = new FileReader();

        reader.readAsBinaryString(this.file);
      }
    },
  },
};
</script>
